import dayjs from "dayjs";

export type GeneratePdfOptionsType =
  | "sendToUser"
  | "sendToBusiness"
  | "download";

export const createInvoiceFileName = ({
  orderId,
  supplierName,
  buyerName,
  confirmedAt,
  invoiceIssuedAt,
  customInvoiceNumber,
  paymentDue,
}: {
  orderId: number;
  supplierName: string;
  buyerName: string;
  confirmedAt: Date | null;
  invoiceIssuedAt: Date | null;
  paymentDue: Date | null;
  customInvoiceNumber: string | null;
}) => {
  return `${
    customInvoiceNumber ?? orderId
  } - ${supplierName} - ${buyerName} - ${dayjs(
    paymentDue ?? invoiceIssuedAt ?? confirmedAt ?? new Date(),
  ).format("DD-MM-YYYY")}.pdf`;
};
